 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Novice_guide~daCase~preview":"Novice_guide~daCase~preview","Novice_guide":"Novice_guide","Student":"Student","Teacher":"Teacher","To_examine":"To_examine","case":"case","caseIndex":"caseIndex","casePolicy~daCase~preview":"casePolicy~daCase~preview","casePolicy":"casePolicy","case_list":"case_list","daCase":"daCase","preview":"preview","caseBasicInformation":"caseBasicInformation","studentHome":"studentHome","experimentManage":"experimentManage","classList":"classList","custom-case":"custom-case","datacenter":"datacenter","doCaseHome":"doCaseHome","forgetpassword":"forgetpassword","notice":"notice","notice_news":"notice_news","personalCenter":"personalCenter","personal_center":"personal_center","process_drill":"process_drill","reportManage":"reportManage","reportManage2":"reportManage2","see_ranking":"see_ranking","stu-datacenter":"stu-datacenter","stu-datacenter-t":"stu-datacenter-t","stureport":"stureport","userList":"userList"}[chunkId]||chunkId) + "." + {"Novice_guide~daCase~preview":"6168a3ff","Novice_guide":"760d473b","Student":"84209ecc","Teacher":"638d749e","To_examine":"9013ade9","case":"f5b13416","caseIndex":"904f9523","casePolicy~daCase~preview":"85e1ee96","casePolicy":"44b383ba","case_list":"7684cbd1","chunk-18aec4e6":"2d770694","chunk-3e85f874":"ea12eef7","daCase":"dfa52b94","preview":"ff0fa76e","chunk-0c19f8a4":"391b5ecd","chunk-50a3bfe2":"7b374161","caseBasicInformation":"93191f52","chunk-53a7f04a":"6ce7f7a1","chunk-13c9cd2d":"18f18f3e","studentHome":"29eeb263","experimentManage":"126fc0d8","classList":"064b8bd6","custom-case":"e5b0116f","datacenter":"a678ecd4","doCaseHome":"edf9e480","forgetpassword":"573f72e6","notice":"848611f6","notice_news":"efb73fd2","personalCenter":"6564eed8","personal_center":"5ec2fb44","process_drill":"daf9a5da","reportManage":"3448d882","reportManage2":"5d9153cb","see_ranking":"89777e75","stu-datacenter":"f0494f5f","stu-datacenter-t":"fdb1c1af","stureport":"b4394aa8","userList":"9f935e82","chunk-de3b359e":"fa599b05","chunk-be31f4ea":"b641efc0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Novice_guide~daCase~preview":1,"Student":1,"Teacher":1,"To_examine":1,"case":1,"caseIndex":1,"casePolicy~daCase~preview":1,"casePolicy":1,"case_list":1,"chunk-3e85f874":1,"daCase":1,"preview":1,"chunk-50a3bfe2":1,"caseBasicInformation":1,"chunk-53a7f04a":1,"chunk-13c9cd2d":1,"studentHome":1,"experimentManage":1,"classList":1,"custom-case":1,"datacenter":1,"forgetpassword":1,"notice":1,"notice_news":1,"personalCenter":1,"personal_center":1,"process_drill":1,"reportManage":1,"reportManage2":1,"see_ranking":1,"stu-datacenter":1,"stu-datacenter-t":1,"stureport":1,"userList":1,"chunk-be31f4ea":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Novice_guide~daCase~preview":"Novice_guide~daCase~preview","Novice_guide":"Novice_guide","Student":"Student","Teacher":"Teacher","To_examine":"To_examine","case":"case","caseIndex":"caseIndex","casePolicy~daCase~preview":"casePolicy~daCase~preview","casePolicy":"casePolicy","case_list":"case_list","daCase":"daCase","preview":"preview","caseBasicInformation":"caseBasicInformation","studentHome":"studentHome","experimentManage":"experimentManage","classList":"classList","custom-case":"custom-case","datacenter":"datacenter","doCaseHome":"doCaseHome","forgetpassword":"forgetpassword","notice":"notice","notice_news":"notice_news","personalCenter":"personalCenter","personal_center":"personal_center","process_drill":"process_drill","reportManage":"reportManage","reportManage2":"reportManage2","see_ranking":"see_ranking","stu-datacenter":"stu-datacenter","stu-datacenter-t":"stu-datacenter-t","stureport":"stureport","userList":"userList"}[chunkId]||chunkId) + "." + {"Novice_guide~daCase~preview":"ee24b15e","Novice_guide":"31d6cfe0","Student":"3fddbd0b","Teacher":"13739f20","To_examine":"c4cb0e31","case":"40a4368f","caseIndex":"34842bbc","casePolicy~daCase~preview":"83ab2ef5","casePolicy":"15e1759d","case_list":"b016a8bc","chunk-18aec4e6":"31d6cfe0","chunk-3e85f874":"72a848f4","daCase":"876748b5","preview":"4879910c","chunk-0c19f8a4":"31d6cfe0","chunk-50a3bfe2":"e4028a4d","caseBasicInformation":"4834374e","chunk-53a7f04a":"44022467","chunk-13c9cd2d":"9edfc60f","studentHome":"c9fed6e8","experimentManage":"bd2c4203","classList":"e9290b5f","custom-case":"b9bbf7e5","datacenter":"c022d045","doCaseHome":"31d6cfe0","forgetpassword":"d4833c2d","notice":"656c32a5","notice_news":"cc641f3a","personalCenter":"5efd0201","personal_center":"3386e32d","process_drill":"481adf27","reportManage":"19892ea8","reportManage2":"b771dad1","see_ranking":"ab06c874","stu-datacenter":"11a7768f","stu-datacenter-t":"c1d76ced","stureport":"b1da663e","userList":"b4372dbb","chunk-de3b359e":"31d6cfe0","chunk-be31f4ea":"5ce9a797"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/policy/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
